import type { ApplicationRecord } from '../types/domain'
import { megaMajorApplications } from './megaMajorApplications'
import { internationalApplications } from './internationalApplications'

export const applications: ApplicationRecord[] = [
  ...megaMajorApplications,
  ...internationalApplications
]
